import { Entity } from './Entity';
import { OepDocument } from './OepDocument';
import { MultiLanguage } from './MultiLanguage';

export class Boep {
    private _id: string;
    private _entity: Entity;
    private _title: MultiLanguage;
    private _description: MultiLanguage;
    private _documents: OepDocument[];
    private _year: number;

    constructor(id: string, title: MultiLanguage, description: MultiLanguage, year: number){
        this._id = id;
        this._title = new MultiLanguage(title);
        this._description = new MultiLanguage(description);
        this._documents = [];
        this._entity = new Entity();
        this._year = year;
    }

    addDocuments(document: OepDocument){
        this._documents.push(document);
    }

    public set id(id: string){
        this._id = id;
    }

    public set documents(documents: OepDocument[]){
        this._documents = documents;
    }
    
    public set title(title: MultiLanguage){
        this._title = title;
    }

    public set description(description: MultiLanguage){
        this._description = description;
    }
    
    public set entity(entity: Entity){
        this._entity = entity;
    }
    
    public set year(year: number){
        this._year = year;
    }

    public get title():MultiLanguage{
        return this._title;
    }

    public get description(): MultiLanguage{
        return this._description;
    }

    public get entity(){
        return this._entity;
    }

    public get id(){
        return this._id;
    }
    
    public get documents(){
        return this._documents;
    }
    
    public get year(){
        return this._year;
    }
}